import { CustomDisplayItem } from "@/components/custom/custom-display-item";
import { Box } from "@mui/material";

import { Link as MuiLink } from "@mui/material";

export const DocumentLink = ({ url, label }) => {
  if (!url)
    return (
      <Box sx={{ backgroundColor: "background.paper" }}>
        <CustomDisplayItem label={label} value="-" />
      </Box>
    );

  return (
    <Box sx={{ backgroundColor: "background.paper" }}>
      <CustomDisplayItem
        label={label}
        value={
          <MuiLink
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            fontSize="0.9rem"
          >
            View Document
          </MuiLink>
        }
      />
    </Box>
  );
};
